<template>
  <div class="index">
    <van-nav-bar title="淋巴瘤诊疗观念调研" fixed left-arrow @click-left="$router.push('/my')" />
    <div class="head"><img src="@/assets/image/my/组 634@2x.png" /></div>
    <div class="box">
      <div class="box-con" v-if="list.length != 0">
        <!-- 1 -->
        <div class="box-item" v-for="(item, index) in list" :key="index">
          <div class="box-left">
            <div class="box-left-title">{{ item.class_text }}</div>
            <div class="box-left-text">说明：按序参与调研，每位用户每月仅限参与一次</div>
            <el-button v-if="item.status == 1" type="primary" size="small"
              @click="viewfillinvestigate(item)">查看问卷</el-button>
          </div>
        </div>
        <!-- 1 -->
      </div>
      <van-empty v-else description="暂无数据" style="position: absolute;top: 0px;left: 50%;transform: translateX(-50%);" />
      <!-- 11 -->
    </div>
  </div>
</template> 
<script>
export default {
  name: 'survey',
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getswitchinfoList()
  },
  methods: {
    viewfillinvestigate(item) {
      if (item.class == 1) this.$router.push({ path: '/surveydel1', query: { id: item.id } })
      if (item.class == 2) this.$router.push({ path: '/surveydel2', query: { id: item.id } })
      if (item.class == 3) this.$router.push({ path: '/surveydel3', query: { id: item.id } })
    },
    //列表 
    async getswitchinfoList() {
      const { data: data } = await this.$http.get("/survey/survey-list");
      this.list = data.data
    },
  }
}  
</script>
<style scoped> .index {
   position: relative;
   width: 100%;
 }

 .head {
   width: 108%;
   position: absolute;
   top: -20px;
   left: -4%;
 }

 .box {
   position: relative;
   top: 0px;
   left: -15px;
   width: 108.8%;
   padding: 20px 15px;
 }

 .box-con {
   padding: 12px;
   background-color: #fff;
   border-radius: 6px;
   height: 100%;
 }

 .box-item {
   position: relative;
   width: 321px;
   height: 141px;
   background: url(@/assets/image/survey/item.png) no-repeat center 0px;
   background-position: center 0px;
   background-size: cover;
   margin-bottom: 14px;
 }

 .box-item:last-child {
   margin-bottom: 0;
 }

 .box-left {
   padding: 24px 0 0 10px;
 }

 .box-left-title {
   color: #2B2B2B;
   font-size: 15px;
   margin-bottom: 5px;
 }

 .box-left-text {
   color: #6B6F97;
   font-size: 13px;
   width: 200px;
   margin-bottom: 15px;
 }

 .box-right {
   position: absolute;
   top: 10px;
   right: 13px;
   width: 66px;
   height: 30px;
 }
</style>     